import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormTipoCertificacion from './FormTipoCertificacion';

import getTipoCertificaciones from '../../../../graphql/querys/otros/getTipoCertificaciones.graphql';
import insertTipoCertificacion from '../../../../graphql/mutations/otros/insertTipoCertificacion.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(insertTipoCertificacion, {
  name: 'insertTipoCertificacion',
  options: {
    refetchQueries: [{ query: getTipoCertificaciones }],
  },
})
class CrearTipoCertificacion extends React.Component {
  constructor(props) {
    super(props);

    // console.log("Entre al constructor");

    this.state = {
      tipo_certificacion: {
        nombre: '',
      },
      step: 0,
      loading: false,
    };

    this.guardarTipoCertificacion = this.guardarTipoCertificacion.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarTipoCertificacion(tipo_certificacion) {
    this.props
      .insertTipoCertificacion({
        variables: {
          nombre: tipo_certificacion.nombre,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        notification.success({
          message: 'Creacion Correcta',
          description:
            'Se ha registrado el nuevo tipo de certificacion de forma exitosa',
        });

        this.props.history.push('/admin/otros/tipo_certificacion');
      })
      .catch(err => {
        console.log('Error en la creacion del tipo de certificacion');
        console.log(err);

        errorService(err, {
          nombre: tipo_certificacion.nombre,
        });

        Modal.error({
          title: 'Error en la creacion del tipo de certificacion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Tipo de Certificacion</Breadcrumb.Item>
          <Breadcrumb.Item>Crear</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Crear Tipo de Certificacion
          </h2>
          <br />
          <div style={estiloContent}>
            <FormTipoCertificacion
              className="formularios"
              onSubmit={this.guardarTipoCertificacion}
              onAnterior={() =>
                this.props.history.push('/admin/otros/tipo_certificacion')
              }
              datos={this.state.tipo_certificacion}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearTipoCertificacion);
